import { useState } from 'react';
import BookCallCTA from '../components/BookCallCTA';
import { allFAQs, faqCategories } from '../data/faqData';
import { useSeo } from '../hooks/useSeo';

export default function FAQPage() {
  const [activeCategory, setActiveCategory] = useState('All');
  useSeo({
    title: 'FAQ | AI ISA Replacement for Realtors | Point Break Systems',
    description: 'Common questions about AI ISA replacement for realtors: cost vs. hiring an ISA, compliance, CRM integrations, 30-second speed to lead, CASL, TCPA, and setup.',
    path: '/faq',
    schemas: [
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        "name": "AI Voice Caller FAQ | Point Break Systems",
        "description": "Frequently asked questions about AI voice callers for real estate agents, brokers, and teams",
        "url": "https://pointbreak.systems/faq",
        "mainEntity": allFAQs.map(faq => ({
          "@type": "Question",
          "name": faq.question,
          "acceptedAnswer": {
            "@type": "Answer",
            "text": faq.answer
          }
        }))
      },
      {
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [
          { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://pointbreak.systems" },
          { "@type": "ListItem", "position": 2, "name": "FAQ", "item": "https://pointbreak.systems/faq" }
        ]
      },
    ],
  });

  const filtered = activeCategory === 'All' ? allFAQs : allFAQs.filter(faq => faq.category === activeCategory);
  return (
    <div className="bg-white min-h-screen"><div className="max-w-4xl mx-auto px-5 sm:px-6 py-8 sm:py-14">
      <header className="mb-6"><h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-3">Your questions, answered.</h1><p className="text-base text-gray-600">Setup, pricing, integrations, and calling requirements.</p></header>
      <div className="mb-6"><label htmlFor="faq-category" className="text-sm font-medium text-gray-700 mr-3">Topic</label><select id="faq-category" value={activeCategory} onChange={e => setActiveCategory(e.target.value)} className="max-w-full rounded-md border border-gray-300 px-3 py-3 text-base bg-white">{['All', ...faqCategories].map(cat => <option key={cat}>{cat}</option>)}</select></div>
      <div key={activeCategory} className="border-t border-gray-200">
        {filtered.map(faq => <details key={faq.question} className="group border-b border-gray-200">
          <summary className="list-none cursor-pointer flex items-start justify-between gap-5 py-4 text-base sm:text-lg font-semibold text-gray-900 [&::-webkit-details-marker]:hidden"><span>{faq.question}</span><span aria-hidden="true" className="shrink-0 text-gray-500 group-open:hidden">+</span><span aria-hidden="true" className="shrink-0 text-gray-500 hidden group-open:inline">−</span></summary>
          <p className="text-base text-gray-600 leading-relaxed pb-5 max-w-3xl">{faq.answer}</p>
        </details>)}
      </div>
      <div className="mt-8 flex flex-col sm:flex-row sm:items-center justify-between gap-5"><div><h2 className="text-xl font-bold text-gray-900">Something specific to your team?</h2><p className="text-base text-gray-600 mt-2">Let's talk through your CRM, market, and lead volume.</p></div><BookCallCTA className="self-start shrink-0" /></div>
    </div></div>
  );
}
